import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../tps.css';

const ReviewerAllPaper = () => {
  const location = useLocation();
  const routeState = location.state || {};

  const platformId = localStorage.getItem('platformID');
  const token = localStorage.getItem('token');
  const API = process.env.REACT_APP_API_BASE_URL;

  const [reviewerPapers, setReviewerPapers] = useState([]);
  const [filteredPapers, setFilteredPapers] = useState([]);
  const [reviewerStats, setReviewerStats] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [decisionFilter, setDecisionFilter] = useState(routeState.status || 'all');
  const [paperTypeFilter, setPaperTypeFilter] = useState(routeState.type || 'all');
  const [page, setPage] = useState(1);
  const perPage = 10;

  let reviewerID = null;

  if (token) {
    const decoded = jwtDecode(token);
    reviewerID = localStorage.getItem("reviewerID");
  }

  // Scroll into view on filter load
  useEffect(() => {
    if (routeState?.type || routeState?.status) {
      setTimeout(() => {
        document.getElementById('resultsTable')?.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    }
  }, []);

  // Fetch reviewer decision comments
  useEffect(() => {
    if (!platformId || !reviewerID) return;

    axios
      .get(`${API}/api/reviewer-comments/comments/${platformId}/${reviewerID}`)
      .then(res => {
        setReviewerPapers(res.data);
        setPage(1);
      })
      .catch(err => {
        console.error("Error fetching reviewer comments:", err);
      });
  }, [platformId, reviewerID]);

  // Fetch reviewer stats (overall + paper type breakdown)
  useEffect(() => {
    if (!platformId || !reviewerID) return;

    axios
      .get(`${API}/api/reviewer/${platformId}/${reviewerID}`)
      .then(res => {
        setReviewerStats(res.data);
      })
      .catch(err => {
        console.error("Error fetching reviewer stats:", err);
      });
  }, [platformId, reviewerID]);

  // Apply search and filters
  useEffect(() => {
    let filtered = reviewerPapers;

    if (decisionFilter !== 'all') {
      filtered = filtered.filter(paper => paper.Decision === decisionFilter);
    }

    if (paperTypeFilter !== 'all') {
      filtered = filtered.filter(paper => {
        const title = paper.SubmissionTitle.toLowerCase();
        if (paperTypeFilter === 'abstract') return title.includes('abstract');
        if (paperTypeFilter === 'full') return title.includes('full');
        if (paperTypeFilter === 'revision') return title.includes('revision');
        return true;
      });
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(paper =>
        paper.AuthorName.toLowerCase().includes(term) ||
        paper.SubmissionTitle.toLowerCase().includes(term)
      );
    }

    setFilteredPapers(filtered);
    setPage(1);
  }, [reviewerPapers, searchTerm, decisionFilter, paperTypeFilter]);

  const paginatedPapers = filteredPapers.slice((page - 1) * perPage, page * perPage);

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text('Reviewer Decision History', 14, 22);

    autoTable(doc, {
      startY: 30,
      head: [['Author', 'Title', 'Decision', 'Date']],
      body: filteredPapers.map(p => [
        p.AuthorName,
        p.SubmissionTitle,
        p.Decision,
        new Date(p.ReviewDate).toLocaleDateString()
      ]),
      styles: { fontSize: 10, cellPadding: 2 },
      theme: 'grid'
    });

    doc.save('reviewer_decisions.pdf');
  };

  const exportToExcel = () => {
    const data = filteredPapers.map(p => ({
      Author: p.AuthorName,
      Title: p.SubmissionTitle,
      Decision: p.Decision,
      Date: new Date(p.ReviewDate).toLocaleDateString()
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reviewer Decisions');
    XLSX.writeFile(workbook, 'reviewer_decisions.xlsx');
  };

  return (
    <div className="container my-4 ml-2">
      <h3 className="page-title mb-4">Reviewer Decision History</h3>

      {/* 🔹 Display Reviewer Stats */}
      {/* {reviewerStats && (
        <div className="my-4">
          <h5>Review Summary</h5>
          <table className="table table-bordered table-sm w-auto">
            <thead>
              <tr>
                <th>Type</th>
                <th>Total</th>
                <th>Accept</th>
                <th>Reject</th>
                <th>Accept w/ Comment</th>
                <th>Pending</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(reviewerStats.paperBreakdown).map(([type, stats]) => (
                <tr key={type}>
                  <td>{type}</td>
                  <td>{stats.total}</td>
                  <td>{stats.Accept}</td>
                  <td>{stats.Reject}</td>
                  <td>{stats.AcceptWithComment}</td>
                  <td>{stats.Pending}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="mt-2">
            <strong>Overall Total:</strong> {reviewerStats.overall.total} |{" "}
            <strong>Accept:</strong> {reviewerStats.overall.Accept} |{" "}
            <strong>Reject:</strong> {reviewerStats.overall.Reject} |{" "}
            <strong>Pending:</strong> {reviewerStats.overall.Pending}
          </div>
        </div>
      )} */}

      {/* 🔎 Search & Filters */}
      <div className="mb-3">
        <input
          type="text"
          className="form-control mb-3"
          style={{ maxWidth: '300px' }}
          placeholder="Search by Author or Title"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="d-flex flex-wrap gap-4">
          <div>
            <strong>Decision:</strong>
            {['all', 'Accept', 'Reject'].map(option => (
              <div className="form-check" key={option}>
                <input
                  type="radio"
                  className="form-check-input"
                  id={`decision-${option}`}
                  value={option}
                  checked={decisionFilter === option}
                  onChange={() => setDecisionFilter(option)}
                />
                <label className="form-check-label" htmlFor={`decision-${option}`}>
                  {option === 'all' ? 'All' : option}
                </label>
              </div>
            ))}
          </div>

          <div>
            <strong>Paper Type:</strong>
            {['all', 'abstract', 'full', 'revision'].map(option => (
              <div className="form-check" key={option}>
                <input
                  type="radio"
                  className="form-check-input"
                  id={`type-${option}`}
                  value={option}
                  checked={paperTypeFilter === option}
                  onChange={() => setPaperTypeFilter(option)}
                />
                <label className="form-check-label" htmlFor={`type-${option}`}>
                  {option === 'all'
                    ? 'All Types'
                    : option.charAt(0).toUpperCase() + option.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 📋 Table */}
      <div className="table-responsive" id="resultsTable">
        <table className="table table-striped table-hover align-middle">
          <thead className="thead-light">
            <tr>
              <th>Author</th>
              <th>Submission Title</th>
              <th>Your Decision</th>
              <th>Date Responded</th>
            </tr>
          </thead>
          <tbody>
            {paginatedPapers.length > 0 ? (
              paginatedPapers.map((paper, idx) => (
                <tr key={paper.Srid ?? idx}>
                  <td>{paper.AuthorName || 'N/A'}</td>
                  <td>{paper.SubmissionTitle || 'Untitled'}</td>
                  <td>
                    {paper.Decision === 'Accept' ? (
                      <span className="badge bg-success">Accept</span>
                    ) : paper.Decision === 'Reject' ? (
                      <span className="badge bg-danger">Reject</span>
                    ) : paper.Decision === 'AcceptWithComment' ? (
                      <span className="badge bg-info text-dark">Accept w/ Comment</span>
                    ) : (
                      <span className="badge bg-warning text-dark">Pending</span>
                    )}
                  </td>
                  <td>
                    {paper.ReviewDate
                      ? new Date(paper.ReviewDate).toLocaleDateString()
                      : 'N/A'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">No reviews found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="d-flex justify-content-between mt-3">
        <button
          className="btn btn-secondary"
          onClick={() => setPage(p => Math.max(p - 1, 1))}
          disabled={page === 1}
        >
          Previous
        </button>
        <span>Page {page}</span>
        <button
          className="btn btn-secondary"
          onClick={() => setPage(p => p + 1)}
          disabled={page * perPage >= filteredPapers.length}
        >
          Next
        </button>
      </div>

      {/* Export Buttons */}
      {filteredPapers.length > 0 && (
        <div className="mt-3">
          <button className="btn btn-success me-2" onClick={exportToPDF}>
            Export to PDF
          </button>
          <button className="btn btn-outline-primary" onClick={exportToExcel}>
            Export to Excel
          </button>
        </div>
      )}
    </div>
  );
};

export default ReviewerAllPaper;
